import { generatePath } from "react-router-dom";

import { ApplicantRecord } from "../../../components/ApplicantReview/applicantRow";
import { AppRoutes } from "../../../config";

// The Portal's tabs, as its own state names them.
export type PortalTab = "trustee" | "ecofutures" | "newTrustee" | "admins";

// What the Portal reads from its router state when it is arrived at from the applicant review, and
// what the Portal leaves on its own history entry when it opens one — so the review's exits and the
// browser's own Back land on the same tab.
export interface PortalLocationState {
  tab?: PortalTab;
}

// What the review page reads from its router state. Only an optimisation — it paints the review
// before the lookup answers, and the page loads the applicant itself without it.
export interface ApplicantReviewLocationState {
  applicant?: ApplicantRecord;
}

export const applicantReviewPath = (address: string) =>
  generatePath(AppRoutes.Profile.subRoutes.ApplicantReview.path, { address });
